import React from "react";
import FadeInSection from "../../../Components/FadeInSection";
import config from "../../../Data/AuthUser.js";


const DashboardTestimonialsViewMore = ({ data, onClose }) => {
  const IMAGE_API_URL = config.apiImageUrl;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
    <div className="w-[0vw] md:w-1/6"></div>
    <div
        className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
      >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">
            Testimonial Details
            {console.log(data)}
          </h2>
          <div className="border-t border-gray-200 mb-6"></div>
          <div className="flex flex-col space-y-8 flex-grow">
            {/* Flex layout for headers and descriptions */}
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Name</p>
              <p className="text-gray-800 w-2/3">{data.name || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Image</p>
              <p className="text-gray-800 w-2/3">{data.image}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Description
              </p>
              <p className="text-gray-800 w-2/3">
                {data.description || "--"}
              </p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Status</p>
              <p className="text-gray-800 w-2/3">
                {data.status === 1 ? "Active" : "Inactive"}
              </p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Tag</p>
              <p className="text-gray-800 w-2/3">{data.tag || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Rating</p>
              <p className="text-gray-800 w-2/3">{data.rating || "--"}</p>
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Author</p>
              <p className="text-gray-800 w-2/3">
                {data.createdby || "--"}
              </p>
            </div>
          </div>
          {/* New division for YouTube video and Image */}
          <div className="flex mt-3 flex-row md:flex-row space-x-6">
            {/* Image section */}
            <div className="flex flex-col w-1/4">
              <p className="text-sm font-medium text-gray-500 mb-2">Image</p>
              <div className="aspect-video bg-gray-100 rounded">
                {data.image ? (
                  <img
                    src={`${IMAGE_API_URL}${data.image}`}
                    alt={"image d"}
                    className="w-full h-full object-cover rounded"
                  />
                ) : (
                  // <img
                  //   src={data.image}
                  //   alt="Blog image"
                  //   className="w-full h-full object-cover rounded"
                  // />
                  <div className="flex items-center justify-center h-full text-gray-500">
                    No image available
                  </div>
                )}
              </div>  
            </div>
          </div>
          <button
            className="self-start px-4 py-2 bg-gray-300 text-black rounded-lg mt-6"
            onClick={() => {
              onClose();
            }}
          >
            Close
          </button>
        </div>
      {/* </FadeInSection> */}
    </div>
  );
};

export default DashboardTestimonialsViewMore;
